define('Components/CagnotteComeInWidget/js/models/CagnotteComeInWidgetInstanceModel',['underscore', 'backbone', 'WidgetInstanceModel', 'app', 'formatPrice', 'moment'], function (_, Backbone, WidgetInstanceModel, app, formatPrice, moment) {
    var DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss ZZ';
    var CagnoetteComeInModel = Backbone.Model.extend({});

    return WidgetInstanceModel.extend({
        name: 'CagnotteComeInWidgetModel',

        getAmount: function () {
            var points = app.getCustomer().get('customer_loyalty_cagnotte');
            return points;
        },
        formatAmount: function () {
            return formatPrice(this.getAmount());
        },
        isExpire: function () {
            return false;
        },
        getUrlHistorique:function () {
          return this.p('url_historique')
        },
        formatExpirationDate: function () {
            var expirationDate = moment(moment(app.getCustomer().getNeolaneParam('amountExpirationDate'), DATE_FORMAT).toDate())
            return expirationDate.format('LL');
        }
    })
});
